/**@param {string}emailInput */
export const VerifyEmailAddress = (emailInput) => {
   let validEmailAddress = {
      msg: '',
      isValid: false,
   };
   let message = '';
   let includeSpaces = false;
   if (emailInput.includes(' ')) {
      message = 'The email is incorrect, it cannot contain spaces';
      includeSpaces = true;
   }
   let includeArroba = emailInput.includes('@');
   let isValidNameBeforeArroba = false;
   if (emailInput.indexOf('@') >= 0) {
      /**@type {number} */
      let index = emailInput.indexOf("@");
      let arrayText = emailInput.split('').splice(0, index);
      if (arrayText.length - 1 >= 1 && arrayText.length - 1 <= 64) {
         isValidNameBeforeArroba = true;
      } else {
         isValidNameBeforeArroba = false;
         message = 'The number of characters before the "@" symbol must be greater than 1 and less than 64'
      }
   } else {
      message = 'The email address is incorrect';
   }
   validEmailAddress = {
      msg: message,
      isValid: includeArroba && isValidNameBeforeArroba && !includeSpaces,
   };
   return validEmailAddress;
}